import styles from "./EmissaoDeColeta.module.css";
import Container from "../../../../components/components-ui/Container/Container";
import Loading from "../../../../components/components-ui/Loading/Loading";
import Button from "../../../../components/components-ui/Button/Button";
import { Table } from "../../../../components/Table";
import { Grid, Col } from "../../../../components/Grid";
import api from "../../../../services/Api";
import { InfoSeachContext } from "../../../../Provider/InfoSearch";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SelectSearch } from "../../../../components/components-ui/SelectSearch/SelectSearch";
import InputClear from "../../../../components/components-ui/InputClear/InputClear";
import { useVerificaPermissao } from "../../../../utils/verificaPermissao";
import { AuthContext } from "../../../../Provider/AuthContext";
import { useOrdenacao } from "../../../../utils/useOrdenacao";

// LINKS
const API_LISTA_DE_COLETA = "/coleta/index?page=";
const API_DADOS_STATUS = `/coleta/status/index`;
const API_LISTA_EMISSOR = `/usuario/view`;

// Colunas da tabela
const columns = [
  {
    column: "Freg",
    key: "codigodaFreguesia",
  },
  {
    column: "Dia",
    key: "DiaRetirada",
  },
  {
    column: "Freguesia Vinculada",
    key: "Freguesia",
  },
  {
    column: "Data da Freguesia Vinculada",
    key: "DataProgramacao",
  },
  {
    column: "Nº Coleta",
    key: "id_coleta",
  },
  {
    column: "REC",
    key: "ColetaRecado",
  },
  {
    column: "Data Agendamento",
    key: "dataAgendamento",
  },
  {
    column: "Nº Pedido",
    key: "NumeroPedido",
  },
  {
    column: "Vol. Estimado",
    key: "Quantidade",
  },
  {
    column: "Etapa",
    key: "etapa",
  },
  {
    column: "Data Pedido",
    key: "data_emissao",
  },
  {
    column: "Emissor",
    key: "Emissor",
  },
  {
    column: "Local",
    key: "nome_local",
  },
  {
    column: "CEP",
    key: "CEP",
  },
  {
    column: "Logradouro",
    key: "Logradouro",
  },
  {
    column: "Status",
    key: "status",
  },
];

export default function EmissaoDeColeta() {
  const { idTipoUsuario } = useContext(AuthContext);
  const verificaPermissao = useVerificaPermissao();

  const [showLoading, setShowLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [status, setStatus] = useState([]);
  const [idEmissor, setIdEmissor] = useState([]);
  const {
    setDataColetaSearch,
    dataColetaSearch,
    filterColetas,
    setFilterColetas,
    coletas,
    setColetas,
  } = useContext(InfoSeachContext);

  const { dados, ordenar, ordem, setDados } = useOrdenacao(coletas, setColetas);

  useEffect(() => {
    //Verifica se o usuario tem permissao para acessar a tela coletas
    verificaPermissao(idTipoUsuario, 45);
  }, []);

  // CARREGA DADOS DO FILTRO
  useEffect(() => {
    async function getListaDeColeta() {
      setShowLoading(true);
      let response = "";

      if (filterColetas) {
        response = await api.get(
          `/coleta/index?page=${currentPage}${filterColetas}`
        );
      } else {
        response = await api.get(
          `${API_LISTA_DE_COLETA}${currentPage}&id_status=1`
        );
      }
      setTotalPages(response.data.totalPages);
      setColetas(response.data.data);
      setCurrentPage(response.data.currentPageNumber);
      setShowLoading(false);
    }
    getListaDeColeta();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, filterColetas]);

  async function getListaDeColetaFiltrada(values) {
    let data = `${
      values?.dataEmissaoDe ? `&data_emissao_de=${values?.dataEmissaoDe}` : ""
    }`;
    data =
      data +
      `${
        values?.dataEmissaoAte
          ? `&data_emissao_ate=${values?.dataEmissaoAte}`
          : ""
      }`;
    data =
      data +
      `${values?.numeroColeta ? `&id_coleta=${values?.numeroColeta}` : ""}`;
    data = data + `${values?.local ? `&nome_local=${values?.local}` : ""}`;
    data = data + `${values?.status ? `&id_status=${values?.status}` : ""}`;
    data =
      data + `${values?.codigoLocal ? `&id_local=${values?.codigoLocal}` : ""}`;
    data =
      data + `${values?.idEmissor ? `&id_emissor=${values?.idEmissor}` : ""}`;

    setCurrentPage(1);
    setFilterColetas(data);

    setDataColetaSearch({
      dataEmissaoDe: values?.dataEmissaoDe,
      dataEmissaoAte: values?.dataEmissaoAte,
      numeroColeta: values?.numeroColeta,
      local: values?.local,
      status: values?.status,
      codigoLocal: values?.codigoLocal,
      idEmissor: values?.idEmissor,
    });
  }

  function resetFilters(resetForm, setFieldValue) {
    resetForm();
    setDataColetaSearch("");
    setFieldValue("numeroColeta", "");
    setFieldValue("dataEmissaoDe", "");
    setFieldValue("dataEmissaoAte", "");
    setFieldValue("codigoLocal", "");
    setFieldValue("local", "");
    setFieldValue("status", 1);
    setFieldValue("idEmissor", "");
    setFilterColetas("");
    setCurrentPage(1);
  }

  // CARREGA DADOS DO FILTRO
  useEffect(() => {
    // Carrega Status
    async function getStatus() {
      const response = await api.get(API_DADOS_STATUS);
      setStatus(response.data.coleta_status);
    }
    getStatus();
    // Carrega ID emissor
    async function getIdEmissor() {
      const response = await api.get(API_LISTA_EMISSOR);
      setIdEmissor(response.data);
    }
    getIdEmissor();
  }, [API_DADOS_STATUS, API_LISTA_EMISSOR]);

  function previewPage() {
    if (currentPage === 1) {
      setCurrentPage(1);
    } else {
      setCurrentPage(currentPage - 1);
    }
  }
  function nextPage() {
    if (currentPage === totalPages) {
      setCurrentPage(totalPages);
    } else {
      setCurrentPage(currentPage + 1);
    }
  }

  const ValidationSchema = Yup.object().shape({
    numeroColeta: Yup.number(),
    dataEmissaoDe: Yup.date().max(
      new Date(),
      "Não é possível filtrar por uma data futura"
    ),
    dataEmissaoAte: Yup.string(),
    codigoLocal: Yup.number(),
    local: Yup.string(),
    status: Yup.string(),
    idEmissor: Yup.string(),
  });

  return (
    <Container>
      <h3>Emissão de Coleta</h3>
      <div className={styles.content}>
        <Link
          to="/usina/action-painel-coleta/novo"
          style={{ display: "contents" }}
        >
          <Button title="Novo" type="button" />
        </Link>
        <Formik
          initialValues={{
            numeroColeta: dataColetaSearch?.numeroColeta
              ? dataColetaSearch?.numeroColeta
              : "",
            dataEmissaoDe: dataColetaSearch?.dataEmissaoDe
              ? dataColetaSearch?.dataEmissaoDe
              : "",
            dataEmissaoAte: dataColetaSearch?.dataEmissaoAte
              ? dataColetaSearch?.dataEmissaoAte
              : "",
            codigoLocal: dataColetaSearch?.codigoLocal
              ? dataColetaSearch?.codigoLocal
              : "",
            local: dataColetaSearch?.local ? dataColetaSearch?.local : "",
            status: dataColetaSearch?.status ? dataColetaSearch?.status : 1,
            idEmissor: dataColetaSearch?.idEmissor
              ? dataColetaSearch?.idEmissor
              : "",
          }}
          validationSchema={ValidationSchema}
          onSubmit={(values) => getListaDeColetaFiltrada(values)}
        >
          {({ errors, touched, resetForm, setFieldValue }) => (
            <Form>
              <section className={styles.wrap}>
                <div className={styles.filter_header}>
                  <strong>Filtros</strong>
                  <div style={{ display: "flex", gap: 10 }}>
                    <Button title="Procurar" type="submit" />
                    <Button
                      type="button"
                      title="Limpar filtros"
                      color="tertiary"
                      onClick={() => resetFilters(resetForm, setFieldValue)}
                    />
                  </div>
                </div>
                <Grid>
                  <Col size={1}>
                    <label>Nº Coleta</label>
                    <Field type="number" name="numeroColeta">
                      {({ field }) => (
                        <InputClear
                          type="number"
                          onClick={() => setFieldValue("numeroColeta", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.numeroColeta && touched.numeroColeta ? (
                      <span className={styles.alertError}>
                        {errors.numeroColeta}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Data Emissão De</label>
                    <Field type="date" name="dataEmissaoDe" />
                    {errors.dataEmissaoDe && touched.dataEmissaoDe ? (
                      <span className={styles.alertError}>
                        {errors.dataEmissaoDe}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Data Emissão Até</label>
                    <Field type="date" name="dataEmissaoAte" />
                    {errors.dataEmissaoAte && touched.dataEmissaoAte ? (
                      <span className={styles.alertError}>
                        {errors.dataEmissaoAte}
                      </span>
                    ) : null}
                  </Col>

                  <Col size={1}>
                    <label>ID Local</label>
                    <Field type="number" name="codigoLocal">
                      {({ field }) => (
                        <InputClear
                          type="number"
                          onClick={() => setFieldValue("codigoLocal", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.codigoLocal && touched.codigoLocal ? (
                      <span className={styles.alertError}>
                        {errors.codigoLocal}
                      </span>
                    ) : null}
                  </Col>

                  <Col size={2}>
                    <label>Nome local</label>
                    <Field
                      type="text"
                      name="local"
                      className={styles.input_style}
                    >
                      {({ field }) => (
                        <InputClear
                          onClick={() => setFieldValue("local", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.local && touched.local ? (
                      <span className={styles.alertError}>{errors.local}</span>
                    ) : null}
                  </Col>

                  <Col size={2}>
                    <label>Status</label>
                    <Field
                      component={SelectSearch}
                      name="status"
                      options={status.map((values) => ({
                        label: values?.status,
                        value: values?.id_status,
                      }))}
                    />
                    {errors.status && touched.status ? (
                      <span className={styles.alertError}>{errors.status}</span>
                    ) : null}
                  </Col>

                  <Col size={2}>
                    <label>Emissor</label>
                    <Field
                      component={SelectSearch}
                      name="idEmissor"
                      options={idEmissor.map((values) => ({
                        label: values?.nome_usuario,
                        value: values?.id_usuario,
                      }))}
                    />
                    {errors.idEmissor && touched.idEmissor ? (
                      <span className={styles.alertError}>
                        {errors.idEmissor}
                      </span>
                    ) : null}
                  </Col>
                </Grid>
              </section>
            </Form>
          )}
        </Formik>
        <div className={styles.container_table}>
          <Table
            edit
            columns={columns}
            onSort={ordenar}
            ordem={ordem}
            className={styles.table}
          >
            {!showLoading &&
              dados.map((values) => (
                <tr key={values?.id_coleta}>
                  <td>
                    <Link
                      to={`/usina/action-painel-coleta/edit/${values?.id_coleta}`}
                    >
                      <i className="fas fa-pencil-alt"></i>
                    </Link>
                  </td>
                  <td>{values?.codigodaFreguesia}</td>
                  <td>{values?.DiaRetirada}</td>
                  <td>{values?.Freguesia}</td>
                  <td>{values?.DataProgramacao}</td>
                  <td
                    className={
                      values?.CorIdColeta === 1
                        ? styles.coleta_tipo1
                        : values?.CorIdColeta === 3
                        ? styles.coleta_tipo3
                        : values?.CorIdColeta === 4
                        ? styles.coleta_tipo4
                        : ""
                    }
                  >
                    {values?.id_coleta}
                  </td>
                  <td>{values?.ColetaRecado}</td>
                  <td>{values?.dataAgendamento}</td>
                  <td>{values?.NumeroPedido}</td>
                  <td>{values?.Quantidade}</td>
                  <td>{values?.etapa}</td>
                  <td>{values?.data_emissao}</td>
                  <td>{values?.Emissor}</td>
                  <td style={{ textAlign: "left" }}>{values?.nome_local}</td>
                  <td>{values?.CEP}</td>
                  <td>{values?.Logradouro}</td>
                  <td>{values?.status}</td>
                </tr>
              ))}
          </Table>
          {coletas.length == 0 && !showLoading ? (
            <p style={{ textAlign: "center", marginBottom: "20px" }}>
              Nenhuma opção encontrada{" "}
            </p>
          ) : (
            ""
          )}
        </div>
        <div className={styles.loading}>
          <Loading display={showLoading ? "block" : "none"} />
        </div>
        <div className={styles.selection_section}>
          <strong>Legenda: </strong>
          <ul className={styles.container_legenda}>
            <li className={styles.container_legenda}>
              <div
                className={styles.square}
                style={{ backgroundColor: "#0b813c" }}
              ></div>
              <span>DENTRO DO PRAZO</span>
            </li>

            <li className={styles.container_legenda}>
              <div
                className={styles.square}
                style={{ backgroundColor: "yellow" }}
              ></div>
              <span>VENCE NO DIA</span>
            </li>
            <li className={styles.container_legenda}>
              <div
                className={styles.square}
                style={{ backgroundColor: "rgb(184, 34, 34)" }}
              ></div>
              <span>ATRASADO</span>
            </li>
          </ul>
        </div>

        <div className={styles.table_pagination}>
          <div className={styles.table_pagination_buttons}>
            <Button
              disabled={currentPage === 1 ? true : false}
              onClick={() => previewPage()}
            >
              <i style={{ marginRight: 5 }} className="fas fa-chevron-left"></i>
              Voltar
            </Button>
            <span>
              {currentPage} De {totalPages}
            </span>

            <Button
              disabled={
                currentPage === totalPages || totalPages === 0 ? true : false
              }
              onClick={() => nextPage()}
            >
              Próxima
              <i style={{ marginLeft: 5 }} className="fas fa-chevron-right"></i>
            </Button>
          </div>
        </div>
      </div>
    </Container>
  );
}
